<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
  <div>Supprimer {{ data?.name || 'cette famille achat couverte' }}</div>
  <button type="button" mat-icon-button (click)="close()" tabindex="-1">
    <mat-icon [icIcon]="icClose"></mat-icon>
  </button>
</div>

<mat-dialog-content fxLayout="column" fxLayoutGap="16px">
  <ng-container *ngIf="hasDependencies; else noDep">
    <p>Les dépendances suivantes ont été détectées :</p>
    <div *ngFor="let d of dependencies.data">
      <p *ngIf="d.dependencies.length > 0" class="font-semibold text-lg text-gray-700 mt-4 mb-2">
        {{ d.name }}
        <span class="item-badge" fxFlex="none">{{ d.dependencies.length }}</span>
      </p>
      <ul class="list-disc pl-4 max-h-40 overflow-y-auto">
        <li *ngFor="let dep of d.dependencies">{{ dep }}</li>
      </ul>
    </div>
    <p>Voulez-vous continuer la suppression ?</p>
  </ng-container>
  <ng-template #noDep>
    <p>Êtes-vous sûr de vouloir supprimer cette famille achat couverte ?</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">NON</button>
  <button mat-button color="primary" [loading]="loading" (click)="deleteItem()">OUI</button>
</mat-dialog-actions>
